function threadToPolyOffset(thread) {
  const face2face = thread.context.face2face;
  const face2side = thread.context.face2side;
  const poly = [
    thread.start.clone().addScaledVector(thread.right, thread.depthRight + face2face).addScaledVector(thread.dir, -face2side),
    thread.start.clone().addScaledVector(thread.right, -(thread.depthLeft + face2face)).addScaledVector(thread.dir, -face2side),
    thread.end.clone().addScaledVector(thread.right, -(thread.depthLeft + face2face)).addScaledVector(thread.dir, face2side),
    thread.end.clone().addScaledVector(thread.right, thread.depthRight + face2face).addScaledVector(thread.dir, face2side)
  ];
  poly.push(poly[0]);
  return poly;
}
export {
  threadToPolyOffset
};
//# sourceMappingURL=index239.js.map
